import type { ShippingDetailsData } from "../../hooks/useShippingDetails";

export type NextShipment = ShippingDetailsData["nextShipments"][number];

export type MedNextShipment = Extract<
  NextShipment,
  { __typename?: "MedNextShipment" }
>;

export type OtcNextShipment = Extract<
  NextShipment,
  { __typename?: "OtcNextShipment" }
>;

export const isMedNextShipment = (
  shipment: NextShipment
): shipment is MedNextShipment => shipment.__typename === "MedNextShipment";

export const isOtcNextShipment = (
  shipment: NextShipment
): shipment is OtcNextShipment => shipment.__typename === "OtcNextShipment";
